import { useAppConfig } from "@hooks/useAppConfig";
import { ConfigProvider } from "antd";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export default function ThemeProvider({
  children,
}: {
  children: Readonly<ReactNode>;
}) {
  const { i18n } = useTranslation();
  const { getColor } = useAppConfig();

  return (
    <ConfigProvider
      direction={i18n.dir()}
      theme={{
        token: {
          fontFamily:
            i18n.dir() === "rtl" ? "Hacen-Liner-Screen" : "satoshi-variable",
          colorPrimary: getColor("activeColor", "#2c4baf"),
          colorError: getColor("errorColor", "#960415"),
          colorSuccess: getColor("successColor", "#20c090"),
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}
